export default "__VITE_ASSET__CU$LjVLZ__"